import { render, staticRenderFns } from "./TheRootstockCollectiveLayout.vue?vue&type=template&id=504a87f5"
import script from "./TheRootstockCollectiveLayout.vue?vue&type=script&lang=js"
export * from "./TheRootstockCollectiveLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports